import React from "react";
import styled from "styled-components";
import { z } from "zod";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { ProductMastheadBladeSchema } from "../../../schemas/blades/ProductMasthead";
import { Backdrop, BackdropBackground } from "../../../components/Backdrop";
import { Media } from "../../../components/Media";
import { BladeContent } from "../../../components/BladeContent";
import { BladeHeader, BladeHeaderSupertitle } from "../../../components/BladeHeader";
import { CTA } from "../../../components/CTA";
import { ContentEngagement } from "../../../components/ContentEngagement";
export const GameSimpleMastheadContractSchema = ProductMastheadBladeSchema.extend({
    type: z.literal("gameSimpleMasthead"),
});
const _GameSimpleMasthead = ({ backdrop, links, logo, tagline, contentList, availability, ...bladeProps }) => {
    const primaryCTA = links?.[0];
    return (React.createElement(Blade, { "data-testid": "game-simple-masthead", ...bladeProps },
        backdrop && (React.createElement(Backdrop, null,
            React.createElement(BackdropBackground, null, backdrop.background && (React.createElement(Media, { "data-testid": "backdrop-background", optimized: true, autoPlay: true, media: backdrop.background }))))),
        React.createElement(BladeContent, { width: "small" },
            React.createElement("div", { className: "top-content" },
                tagline && (React.createElement(BladeHeader, null,
                    React.createElement(BladeHeaderSupertitle, null, tagline))),
                logo?.image && (React.createElement(ContentEngagement, { action: logo.action, contentAnalytics: {
                        id: "logo-link",
                        uiType: "LogoLink",
                        imageUrl: logo?.image?.url || "",
                        action: logo.action,
                    } },
                    React.createElement(Media, { className: "logo", "data-testid": "masthead-logo", media: logo.image }))),
                primaryCTA && React.createElement(CTA, { ...primaryCTA, variant: "primary", ornamental: true })),
            availability && (React.createElement("div", { className: "availability-container" },
                availability.title && (React.createElement("p", { "data-testid": "availability-title", className: "availability-title" }, availability.title)),
                !!availability.links?.length && (React.createElement("div", { className: "badges-container" }, availability.links.map((iconLink) => {
                    return iconLink.media ? (React.createElement(ContentEngagement, { "data-testid": `availability-link-${iconLink.iconName}`, key: iconLink.iconName, action: iconLink.link.action, contentAnalytics: {
                            id: `availability-link-${iconLink.iconName}`,
                            title: iconLink.link.title,
                            uiType: "AvailabilityLink",
                            action: iconLink.link.action,
                        } },
                        React.createElement(Media, { media: iconLink.media }))) : null;
                }))))))));
};
export const GameSimpleMasthead = styled(_GameSimpleMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=GameSimpleMasthead.js.map